/* ============================================================================
   Tokens de la capa FormKit (color + tipografía) — parte del token store central
   del repo (src/styles/tokens/). Los consume src/components/product_config/formkit.jsx.
   · color: referencia a las CSS vars centrales (styles/yool-admin.css) con
            fallback hex → soporta dark mode y estilos inline en React.
   · type:  presets tipográficos = los roles del design system
            (pageTitle, panelHeader, sectionTitle, label, hint, …).
   Una sola definición; misma paleta Yool que yoolColors / --yool-*.
   ============================================================================ */
const v = (name, fallback) => `var(${name}, ${fallback})`;

export const color = {
  black:    v("--yool-black", "#1A1A1A"),
  text:     v("--yool-black", "#1A1A1A"),
  cta:      v("--yool-cta", "#007D6E"),
  ctaHover: v("--yool-teal-hover", "#006358"),
  ctaSoft:  v("--yool-teal-soft", "#E6F3F1"),
  cyan:     v("--yool-cyan", "#06B6D4"),
  info:     v("--yool-cyan", "#06B6D4"),
  navy:     v("--yool-navy", "#0E2640"),
  sub:      v("--yool-gray1", "#54585A"),
  muted:    v("--yool-muted", "#8D8D8D"),
  head:     "#9499A0",
  border:   v("--yool-border", "#E0E0E0"),
  line:     v("--yool-line", "#ECECEC"),
  field:    v("--yool-field", "#FBFBFB"),
  surface:  v("--white", "#FFFFFF"),
  gray:     v("--yool-gray", "#EBEBEB"),
  page:     v("--yool-page", "#F7F7F7"),
  /* estados (no-teal) */
  ok:        v("--yool-success", "#158B5C"),
  okBg:      v("--yool-success-soft", "#E8F5EE"),
  okText:    "#0A5C36",
  err:       "#C0004A",
  errBorder: v("--yool-error", "#ED4068"),
  errBg:     v("--yool-error-soft", "#FDEDF1"),
  warn:      "#B7791F",
  warnBg:    "#FBF3E2",
  warnBorder:"#EBD9AE",
  warnText:  "#8A5A09",
  /* FancyYool (títulos coloreados) */
  blue:   v("--fy-blue", "#2563EB"),
  violet: v("--fy-violet", "#5B2BE5"),
  /* fuentes */
  font: v("--font-sans", "'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif"),
  mono: v("--font-mono", "'SF Mono', ui-monospace, monospace"),
};

export const type = {
  pageTitle:    { fontSize: 30, fontWeight: 700, letterSpacing: "-0.03em", lineHeight: 1.1, color: color.text },
  pageSub:      { fontSize: 15, lineHeight: 1.55, color: color.sub },
  panelHeader:  { fontSize: 19, fontWeight: 700, letterSpacing: "-0.01em", color: color.text },
  panelDesc:    { fontSize: 13.5, lineHeight: 1.5, color: color.muted },
  sectionTitle: { fontSize: 17, fontWeight: 700, letterSpacing: "-0.02em", color: color.text },
  sectionDesc:  { fontSize: 13.5, lineHeight: 1.5, color: color.sub },
  label:        { fontSize: 11, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", color: color.muted },
  hint:         { fontSize: 12, lineHeight: 1.5, color: color.muted },
  eyebrow:      { fontSize: 10, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", color: color.head },
  body:         { fontSize: 14, lineHeight: 1.5, color: color.text },
  bodySm:       { fontSize: 13, lineHeight: 1.45, color: color.sub },
  mono:         { fontSize: 12.5, lineHeight: 1.55, fontFamily: color.mono },
};

/* Radii del design system */
export const radius = { xs: 4, sm: 8, md: 10, lg: 12, xl: 16, pill: 999 };
